import { render, staticRenderFns } from "./chooseBuild.vue?vue&type=template&id=7527eb7b&scoped=true"
import script from "./chooseBuild.vue?vue&type=script&lang=js"
export * from "./chooseBuild.vue?vue&type=script&lang=js"
import style0 from "./chooseBuild.vue?vue&type=style&index=0&id=7527eb7b&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527eb7b",
  null
  
)

export default component.exports